export function isDevEnvironment(): boolean {
  return import.meta.env.DEV;
}

export function isProductionEnvironment(): boolean {
  return import.meta.env.PROD;
}

/**
 * Returns true if the platform is Macintosh, or false otherwise.
 */
export function isMacintoshPlatform(): boolean {
  // Try modern API first
  // @ts-expect-error - userAgentData is the new API for checking platform.
  if (window.navigator.userAgentData?.platform != null) {
    // @ts-expect-error - userAgentData is the new API for checking platform.
    return window.navigator.userAgentData.platform === "macOS";
  }

  // Fall back to user agent string
  return /Mac/i.test(window.navigator.userAgent);
}

export function consoleWarnInDevelopmentModeOnly(...params: Parameters<typeof console.warn>): void {
  if (!isProductionEnvironment()) {
    console.warn("%c[Development warning]", "font-weight: bold; color: #E0A04C", ...params);
  }
}
